var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home1"},[_c('Other-Website',{attrs:{"domain":_vm.webUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }